import React, { useEffect, useState } from "react";
import {
  Input,
  InputNumber,
  Select,
  DatePicker,
  Form,
  Col,
  Row,
  Button,
  Collapse,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper";
import RequestHandler from "../../util/RequestHandler";

const { RangePicker } = DatePicker;

function SweepPaymentListFilter(props) {
  const [form] = Form.useForm();
  const [banks, setBanks] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/Bank?$select=id,name&$orderby=name`).then((response) => {
      if (response && Array.isArray(response.value)) {
        setBanks(response.value);
      }
    });
    RequestHandler.get(`/Currency?$select=id,code&$orderby=code`).then((response) => {
      if (response && Array.isArray(response.value)) {
        setCurrencies(response.value);
      }
    });
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    const conditions = [];

    if (values.ruleName) {
      conditions.push(odata.contains("ruleName", values.ruleName));
    }

    if (values.senderText) {
      conditions.push(
        `(${odata.contains("senderAccountName", values.senderText)} or ${odata.contains(
          "senderIban",
          values.senderText
        )})`
      );
    }

    if (values.receiverText) {
      conditions.push(odata.contains("receiverIban", values.receiverText));
    }

    if (values.senderBankName) {
      conditions.push(odata.contains("senderBankName", values.senderBankName));
    }

    if (values.receiverBankName) {
      conditions.push(odata.contains("receiverBankName", values.receiverBankName));
    }

    const amountQuery = odata.ConditionalRange(
      "amount",
      values.amountMin,
      values.amountMax
    );
    if (amountQuery) {
      conditions.push(amountQuery);
    }

    if (values.currencyCode) {
      conditions.push(`currencyCode eq '${values.currencyCode}'`);
    }

    if (values.paymentDate && values.paymentDate.length === 2) {
      conditions.push(
        odata.dateRange("paymentDate", values.paymentDate[0], values.paymentDate[1])
      );
    }

    const query = conditions.length !== 0 ? conditions.join(" and ") : "";

    if (props.onFinishFilter) props.onFinishFilter(query, values);
  };

  const clearFilter = () => {
    form.resetFields();
    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="sweepPaymentFilter"
              form={form}
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }} gutter={12}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Kural" name="ruleName">
                    <Input placeholder="Kural adı giriniz" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Gönderen Banka" name="senderBankName">
                    <Select
                      placeholder="Gönderen banka seçiniz"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {banks.map((item) => (
                        <Select.Option key={item.id} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Gönderen Hesap" name="senderText">
                    <Input placeholder="Ad veya IBAN giriniz" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Alıcı Banka" name="receiverBankName">
                    <Select
                      placeholder="Alıcı banka seçiniz"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {banks.map((item) => (
                        <Select.Option key={item.id} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Alıcı Hesap" name="receiverText">
                    <Input placeholder="IBAN giriniz" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Tutar" style={{ marginBottom: 0 }}>
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber
                              min={0}
                              style={{ width: "100%" }}
                              placeholder="Min"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber
                              min={0}
                              style={{ width: "100%" }}
                              placeholder="Max"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Para Birimi" name="currencyCode">
                    <Select placeholder="Para birimi seçiniz" allowClear>
                      {currencies.map((item) => (
                        <Select.Option key={item.id} value={item.code}>
                          {item.code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Ödeme Tarihi" name="paymentDate">
                    <RangePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
}

export default SweepPaymentListFilter;
